import { Filters, maskFilterApi } from '../filtering';
import { Common } from '../common';


export const checkDateInPeriod = (date: Date, period: Common.DateRange) =>
    date >= period.From && date <= period.To;


export const registersFilters = {
    type: <Filters.MaskFilterWithApply>{
        dict: 'registerTemplates',
        api: maskFilterApi('registerTemplateMask'),
        applyFilter: (value, { RegisterTemplateCode }) =>
            value.includes(RegisterTemplateCode),
    },
    status: <Filters.MaskFilterWithApply>{
        dict: 'registerStatuses',
        api: maskFilterApi('registerStatusMask'),
        applyFilter: (value, { RegisterStatusCode }) =>
            value.includes(RegisterStatusCode),
    },
    stage: <Filters.MaskFilterWithApply>{
        dict: 'registerStages',
        api: maskFilterApi('registerStageMask'),
        applyFilter: (value, { RegisterStageCode }) =>
            value.includes(RegisterStageCode),
    },
    signAllowed: <Filters.FilterWithApply>{
        api: ({ value }) => ({
            isSignAllowed: value,
        }),
        applyFilter: (value, { IsSignAllowed }) =>
            value === IsSignAllowed,
    },
    searchField: <Filters.FilterWithApply>{
        api: ({ value }) => ({
            searchField: value,
        }),
        applyFilter: () => false,
    },
    processTemplate: <Filters.MaskFilterWithApply>{
        dict: 'processTemplateInstances',
        api: maskFilterApi('processTemplateInstanceMask'),
        applyFilter: (value, { ProcessTemplateInstanceCode }) =>
            value.includes(ProcessTemplateInstanceCode),
    },
    // processTemplateInstance: <Filters.MaskFilterWithApply>{
    //     dict: 'processTemplateInstances',
    //     api: maskFilterApi('processTemplateInstanceMask'),
    //     applyFilter: (value, { ProcessTemplateInstanceCode }) =>
    //         value.includes(ProcessTemplateInstanceCode),
    // },
    processing: <Filters.FilterWithApply>{
        api: ({ value }) => ({
            isProcessing: value,
        }),
        applyFilter: (value, { IsProcessing }) =>
            value === IsProcessing,
    },
    clientId: <Filters.FilterWithApply>{
        api: ({ value }) => ({
            clientORProviderUid: value,
        }),
        applyFilter: (value, { ClientORProviderId }) =>
            value === ClientORProviderId,
    },
    factorId: <Filters.FilterWithApply>{
        api: ({ value }) => ({
            factorUid: value,
        }),
        applyFilter: (value, { FactorId }) =>
            value === FactorId,
    },
    debtorId: <Filters.FilterWithApply>{
        api: ({ value }) => ({
            debtorORBuyerUid: value,
        }),
        applyFilter: (value, { DebtorORBuyerId }) =>
            value === DebtorORBuyerId,
    },
    startDate: <Filters.FilterWithApply<Common.DateRange>>{
        api: ({ value }) => ({
            registerStartDateRange: value,
        }),
        applyFilter: (value, { RegisterStartDate }) =>
            checkDateInPeriod(RegisterStartDate, value),
    },
    endDate: <Filters.FilterWithApply<Common.DateRange>>{
        api: ({ value }) => ({
            registerEndDateRange: value,
        }),
        applyFilter: (value, { RegisterEndDate }) =>
            checkDateInPeriod(RegisterEndDate, value),
    },
};
